// Hardware group page. Mirrors the shape of warehouse.tsx — a small
// AdminPageHeader + 2 tiles linking to the existing Devices and
// Printers admin pages. Lives under /admin/hardware so the admin
// homepage can group "physical equipment" together rather than having
// devices and printers as siblings of Settings.
import { Smartphone, Printer } from "lucide-react";
import AdminPageHeader from "../components/admin-page-header";
import AdminTile from "../components/admin/AdminTile";
import "../styles/admin-home.css";

const AdminHardware = () => (
    <div className="page-data page-data-wide">
        <AdminPageHeader
            titleKey="hardware"
            backTo="/admin"
            hideSearch
            crumbs={[
                { labelKey: "admin_panel", to: "/admin" },
                { labelKey: "hardware" },
            ]}
        />
        <div className="admin-home-tiles">
            <AdminTile
                to="/admin/devices"
                labelKey="devices"
                icon={<Smartphone size={24} strokeWidth={1.5} />}
                tone="blue"
            />
            <AdminTile
                to="/admin/printers"
                labelKey="printers"
                icon={<Printer size={24} strokeWidth={1.5} />}
                tone="purple"
            />
        </div>
    </div>
);

export default AdminHardware;
